import styled from 'styled-components'
import { Typography } from 'common/typography'
import { SecondaryButton } from 'common/button'
import Link from 'next/link'
import ProjectStatus from './project-in-progress-state'

const ProjectsInProgressStyled = styled.div`
  .projects-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .projects-title {
    display: flex;
    justify-content: space-between;
  }
  .turquoise {
    color: var(--turquoise);
    font: var(--regularBold);
  }
  .projects-count {
    display: flex;
    flex-direction: column;
    gap: .5rem;
  }
  .project-in-progress {
    display: flex;
    align-items: center;
    gap: .5rem;
    img {
      border-radius: 50%;
    }
    &-state {
      color: var(--turquoise);
      font: var(--smallBold);
    }
  }
  .max {
    font: var(--smallRegular);
    text-align: center;
    width: 100%;
    display: inline-block;
  }
  .progress-bar {
    margin-block-start: .5rem;
    height: .5rem;
    border-radius: 1rem;
    background: #10fefe33;
    position: relative;
    &:after {
      border-radius: 1rem;
      position: absolute;
      background: #10fefe;
      content: "";
      height: .5rem;
      right: ${({ progress }) => `${100 - progress}%`};
      left: 0;
    }
  }
`

function ProjectsInProgress({ projects, total, completed }) {
  return (
    <ProjectsInProgressStyled className="progress-item" progress={(completed * 100) / total}>
      <div>
        <div className="projects-title">
          <Typography font="regularBold">Proyectos</Typography>
          {completed ? (
            <span className="turquoise">
              {Math.floor((completed * 100) / total)}
              %
            </span>
          ) : (
            <span className="turquoise">
              0%
            </span>
          )}
        </div>
        <div className="progress-bar" />
      </div>
      {(projects.length || completed) ? (
        <div className="projects-count">
          {projects.length ? (
            <Typography as="span" font="p2Regular">
              {projects.length}
              {' '}
              proyectos en curso
            </Typography>
          ) : null}
          {completed ? (
            <Typography as="span" font="p2Regular">
              {completed}
              {' '}
              proyectos aprobados
            </Typography>
          ) : null}
        </div>
      ) : null}
      {!completed ? (
        <p>Los proyectos son la experiencia que necesitas para buscar un trabajo.</p>
      ) : null}
      <ul className="projects-list">
        {projects.map(({ project, state }) => (
          <li key={project.slug}>
            <Link href={`/proyectos/${project.slug}#revision`} className="project-in-progress">
              <img src={project.thumb_image} width="48" height="48" alt={`Thumbnail del proyecto ${project.title}`} />
              <div>
                <Typography font="p2Bold">{project.title}</Typography>
                <ProjectStatus state={state} />
              </div>
            </Link>
          </li>
        ))}
      </ul>
      <div>
        <Link href={projects.length ? '/estudiante#mis-proyectos' : '/proyectos/todos'} passHref>
          <SecondaryButton fullWidth>
            {projects.length ? 'Ver mis proyectos' : 'Elegir mi primer proyecto'}
          </SecondaryButton>
        </Link>
        <span>
          {!projects.length ? (
            <Typography as="span" className="max">
              *Puedes tener hasta 5 proyectos en curso.
            </Typography>
          ) : null}
        </span>
      </div>
    </ProjectsInProgressStyled>
  )
}

export default ProjectsInProgress
